export default "__VITE_ASSET__r31_BrIpXQObrZugsc5Rjw__"